(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
			this.headerHeightRafId = null;
			this.lastHeaderHeight = 0;
			this.headerTransparent = this.header.querySelector('.header-transparent');
				
			if(this.headerTransparent){
				this.headerTransparent.classList.add('js-active');
				const setTopPosition = () => { 
          const nextHeaderHeight = this.header.offsetHeight;
          if (nextHeaderHeight === this.headerTopPosition) return;
          this.headerTopPosition = nextHeaderHeight;
          this.header.style.marginBottom = `-${nextHeaderHeight}px`;
				}

        setTopPosition();

        let resizeTimeout;
        this.transparentHeaderResizeHandler = () => {
					clearTimeout(resizeTimeout);
					resizeTimeout = setTimeout(setTopPosition, 60);
        };
        window.addEventListener('resize', this.transparentHeaderResizeHandler, { passive: true });

				document.body.classList.add('header-transparent-active');
      } 

      this.scheduleHeaderHeightUpdate();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.scheduleHeaderHeightUpdate.bind(this));
      window.addEventListener('resize', this.scheduleHeaderHeightUpdate.bind(this), { passive: true });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    scheduleHeaderHeightUpdate() {
      if (this.headerHeightRafId) return;
      this.headerHeightRafId = requestAnimationFrame(() => {
        this.headerHeightRafId = null;
        this.setHeaderHeight();
      });
    }

    setHeaderHeight() {
      const nextHeight = this.header.offsetHeight;
      if (nextHeight === this.lastHeaderHeight) return;
      this.lastHeaderHeight = nextHeight;
      document.documentElement.style.setProperty('--header-height', `${nextHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
			if (this.headerHeightRafId) {
				cancelAnimationFrame(this.headerHeightRafId);
				this.headerHeightRafId = null;
			}
      if (this.transparentHeaderResizeHandler) {
        window.removeEventListener('resize', this.transparentHeaderResizeHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop === 0 ) {
				this.classList.add('header-at-top');
			} else {
				this.classList.remove('header-at-top');
			}		

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
